/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { DatasetImportStatus } from '../types/dataset/DatasetImportStatus';

export const datasetImportStatusColors = {
  [DatasetImportStatus.Idle]: '#35B44E',
  [DatasetImportStatus.Pending]: '#F8A31A',
  [DatasetImportStatus.Importing]: '#1F3F6D',
  [DatasetImportStatus.Aborting]: '#A2A7AE',

  __fallback: '#E2E2E2',
};
